import classNames from 'classnames'

export function getMenuItemColorClasses({
  isSelected,
  isActive,
  isDisabled,
}: {
  isSelected?: boolean
  isDisabled?: boolean
  isActive?: boolean
}) {
  const baseClasses = 'font-size-normal font-weight-semibold pointer'

  if (isDisabled) {
    return classNames(
      baseClasses,
      'background-transparent shade-30 cursor-forbidden'
    )
  }

  if (isSelected) {
    return classNames(
      baseClasses,
      'background-alpha-blue-50 blue-20',
      'background-alpha-blue-45-on-hover blue-10-on-hover',
      'background-alpha-blue-40-on-active blue-10-on-active',
      'background-alpha-blue-45-on-focus blue-10-on-focus'
    )
  }

  if (isActive) {
    return classNames(baseClasses, 'background-alpha-shade-50')
  }

  return classNames(
    baseClasses,
    'background-transparent',
    'background-alpha-shade-55-on-hover',
    'background-shade-50-on-focus',
    'background-shade-50-on-active background-shade-60-on-dark-mode-active'
  )
}
